module.exports = __webpack_public_path__ + "static/img/ALE-2.7160df01.png";